import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { ActionSchema } from '../types/actionSchema';
import { fetchActionsByTypeProduct } from '../services/fetchActionsByTypeProduct/fetchActionsByTypeProduct';
import { fetchActionsByProduct } from '../services/getActionsByProduct/getActionsByProduct';
import { fetchActionByBrand } from '../services/fetchActionByBrand';

const initialState: ActionSchema = {
  listByTypeProduct: null,
  actionsByProduct: null,
  badgesByProduct: null,
  isLoading: false,
  listActionByBrand: null,
};

export const actionsSlice = createSlice({
  name: 'actions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.actions,
      };
    });
    builder.addCase(fetchActionsByTypeProduct.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(fetchActionsByTypeProduct.fulfilled, (state, action) => {
      if (action.payload) {
        state.listByTypeProduct = action.payload;
      }
      state.isLoading = false;
    });
    builder
      .addCase(fetchActionsByProduct.pending, state => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(fetchActionsByProduct.fulfilled, (state, action) => {
        if (action.payload) {
          state.actionsByProduct = action.payload?.actions;
          state.badgesByProduct = action.payload?.stickers;
        }
        state.isLoading = false;
      })
      .addCase(fetchActionsByProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchActionByBrand.fulfilled, (state, action) => {
        if (action.payload) {
          state.listActionByBrand = action.payload;
        }
      })
      .addCase(fetchActionByBrand.rejected, state => {
        state.listActionByBrand = [];
      });
  },
});

export const { actions: actionsActions } = actionsSlice;
